export interface DashboardStats {
  admins: number;
  properties: number;
  residents: number;
  vendors: number;
  amenityBookings: number;
  petRegistries: number;
}

export interface CalendarEvent {
  id: number;
  title: string;
  titleKey?: string;
  date: Date;
  type: EventType;
  description?: string;
  descriptionKey?: string;
  color: string;
  sourceType: EventSourceType;
  sourceId: number;
  startTime?: Date;
  endTime?: Date;
  location?: string;
  locationKey?: string;
  isAllDay?: boolean;
}

export enum EventType {
  MAINTENANCE = 'maintenance',
  MEETING = 'meeting',
  EVENT = 'event',
  DEADLINE = 'deadline',
}

export enum EventSourceType {
  REQUEST = 'request',
  BOOKING = 'booking',
  ANNOUNCEMENT = 'announcement',
  INVOICE = 'invoice',
  MAINTENANCE = 'maintenance',
}
